<template>
	<div class="p-2 d-flex align-items-start">
		<div class="flex-grow-1 mr-3">
			<b-row>
				<b-col md="2">
					<FormGroup
						:state="!salutationError"
						:invalid-feedback="salutationError"
						feedback-beneath
					>
						<SalutationSelect
							v-model="salutation"
							placeholder="Anrede"
							@input="emitChangeEvent"
						/>
					</FormGroup>
				</b-col>
				<b-col md="3">
					<FormGroup
						:state="!firstNameError"
						:invalid-feedback="firstNameError"
						feedback-beneath
					>
						<b-input v-model="firstName" placeholder="Vorname" @input="emitChangeEvent"/>
					</FormGroup>
				</b-col>
				<b-col md="4">
					<FormGroup
						:state="!lastNameError"
						:invalid-feedback="lastNameError"
						feedback-beneath
					>
						<b-input v-model="lastName" placeholder="Nachname" @input="emitChangeEvent"/>
					</FormGroup>
				</b-col>
				<b-col md="3">
					<FormGroup
						:state="!roleError"
						:invalid-feedback="roleError"
						feedback-beneath
					>
						<b-input v-model="role" placeholder="Funktion" @input="emitChangeEvent"/>
					</FormGroup>
				</b-col>
			</b-row>
		</div>
		<div class="d-flex align-items-center pt-2">
			<a href="#" @click.prevent="$emit('remove')">
				<Icon icon="minus-circle" color="black" size="1comma5x"/>
			</a>
			<a href="#" @click.prevent="$emit('add')" :class="['ml-2', {'invisible': !isLast}]">
				<Icon icon="plus-circle" color="black" size="1comma5x"/>
			</a>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import {isEmptyOrNull} from "@/helper/String";
import FormGroup from "@/vue/common/form/Group";
import SalutationSelect from "@/vue/common/form/SalutationSelect";
import {isDefined} from "@/helper/Value";
import _ from "lodash";

export default {

	components: {
		Icon,
		FormGroup,
		SalutationSelect,
	},

	props: {
		participant: {
			type: Object,
			required: true,
		},
		isLast: {
			type: Boolean,
			required: true
		}
	},

	data ()
	{
		return {
			salutation: this.participant.salutation,
			firstName: this.participant.firstName,
			lastName: this.participant.lastName,
			role: this.participant.role,
		};
	},

	computed: {
		salutationError ()
		{
			return !isDefined(this.salutation)
				? 'Pflichtfeld'
				: undefined;
		},
		salutationValid ()
		{
			return !isDefined(this.salutationError);
		},
		firstNameError ()
		{
			return this.validate(this.firstName);
		},
		lastNameError ()
		{
			return this.validate(this.lastName);
		},
		roleError ()
		{
			return this.validate(this.role);
		},
		valid ()
		{
			return this.salutationValid
				&& !this.firstNameError
				&& !this.lastNameError
				&& !this.roleError;
		},
	},

	methods: {
		validate (value)
		{
			if (isEmptyOrNull(value))
			{
				return 'Pflichtfeld';
			}

			value = _.trim(value);

			if (value.length < 2)
			{
				return 'Mindestens 2 Zeichen';
			}

			if (value.length > 30)
			{
				return 'Maximal 30 Zeichen erlaubt';
			}

			if (!value.match(/^[^0123456789.,@()_\/\[\]]+$/))
			{
				return 'Folgende Zeichen sind nicht erlaubt: 1 2 3 4 5 6 7 8 9 0 . @ ( ) _ , / [ ]';
			}

			return null;
		},
		emitChangeEvent ()
		{
			this.$emit('change', {
				salutation: this.salutation,
				firstName: this.firstName,
				lastName: this.lastName,
				role: this.role,
				valid: this.valid,
			});
		},
	}
}
</script>
